module.exports = __webpack_public_path__ + "img/NL163.9d394906.png";